import React, { memo } from 'react';
import { Typography } from '@mui/material';
import {
  HowGuide,
  HowStepGrid,
  HowStep,
  StepNumberBadge,
} from '../ReservationSlotManagement.styles';

/**
 * 手順ガイドの1ステップ定義
 *
 * @property {number} step - ステップ番号（1始まり）
 * @property {string} title - ステップの見出し
 * @property {string} description - ステップの補足説明
 */
interface HowStepItem {
  step: number;
  title: string;
  description: string;
}

/**
 * 解放枠設定画面の作業手順（3ステップ）
 *
 * @description
 * 画面内で完結する固定の案内文のため、Propsではなく定数として保持する。
 */
const HOW_STEPS: readonly HowStepItem[] = [
  {
    step: 1,
    title: 'テンプレートを確認',
    description: '登録済みのテンプレートから設定内容を把握してください',
  },
  {
    step: 2,
    title: '基本設定・個別上書きを確認',
    description: '全医師のデフォルトと個別上書きが自動で割り当たります',
  },
  {
    step: 3,
    title: '確認して一括生成',
    description: '内容を確認し、「一括生成」ボタンで完了',
  },
];

/**
 * 解放枠設定画面の手順ガイド
 *
 * @description
 * 解放枠設定画面の冒頭に置く、3ステップの静的な作業手順ガイド。
 * 状態を持たず表示内容も固定のためPropsを受け取らない。
 *
 * @returns {React.ReactElement} 手順ガイド
 */
const SetupHowGuide: React.FC = memo(() => (
  <HowGuide>
    <HowStepGrid>
      {HOW_STEPS.map((item) => (
        <HowStep key={item.step}>
          <StepNumberBadge $filled={false} sx={{ mb: 1 }}>
            {item.step}
          </StepNumberBadge>
          <Typography sx={{ fontSize: 12.5, fontWeight: 700, mb: 0.5 }}>{item.title}</Typography>
          <Typography sx={{ fontSize: 11.5, color: 'text.secondary', lineHeight: 1.6 }}>
            {item.description}
          </Typography>
        </HowStep>
      ))}
    </HowStepGrid>
  </HowGuide>
));

SetupHowGuide.displayName = 'SetupHowGuide';

export default SetupHowGuide;
